// import React, { useState, useEffect } from 'react';
// import Header from '../../components/ui/Header';
// import Footer from '../../components/ui/Footer';

// const BrandPage = () => {

//   const baseUrl = "https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/brand-book/";
//   const brandContent = [
//     {
//       section: "Overview",
//       images: [
//         { fileName: "MacBook Pro 16_ - 1.png", label: "Overview" },
//       ],
//     },
//     {
//       section: "Typography",
//       images: [
//         { fileName: "MacBook Pro 16_ - 2.png", label: "Typography" },
//         { fileName: "MacBook Pro 16_ - 11.png", label: "Web Fonts" },
//       ],
//     },
//     {
//       section: "Pallet",
//       images: [
//         { fileName: "MacBook Pro 16_ - 3.png", label: "Pallet" },
//         { fileName: "Group 122.png", label: "Additional colours" },
//       ],
//     },
//     {
//       section: "Blue Print",
//       images: [
//         { fileName: "MacBook Pro 16_ - 4.png", label: "Symbol" },
//         { fileName: "MacBook Pro 16_ - 5.png", label: "Logo" },
//       ],
//     },
//     {
//       section: "Ideology",
//       images: [
//         { fileName: "MacBook Pro 16_ - 6.png", label: "symbol encoding" },
//         { fileName: "MacBook Pro 16_ - 7.png", label: "Inspiration" },
//         { fileName: "MacBook Pro 16_ - 8.png", label: "Values" },
//       ],
//     },
//     {
//       section: "Assets",
//       images: [
//         { fileName: "MacBook Pro 16_ - 9.png", label: "Branding assets" },
//         { fileName: "Streen_Sign_Mockup_21 1.png", label: "Street sign" },
//         { fileName: "Billboard_Mockup_4 1.png", label: "Bullboard" },
//       ],
//     },
//     {
//       section: "Download materials",
//  images: [
//         { fileName: "MacBook Pro 16_ - 10.png", label: "Cosmelytix Logo" },
//       ],
//     },
//   ];

//   // Flatten the image files for scroll tracking
//   const flatImageFiles = brandContent.reduce((acc, section) => {
//     return acc.concat(section.images);
//   }, []);

//   const generateId = (str) => {
//     return str.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
//   };


//   const [activeImageId, setActiveImageId] = useState(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       let currentActiveId = null;
//       for (const image of flatImageFiles) {
//         const id = generateId(image.fileName);
//         const element = document.getElementById(id);
//         if (element) {
//           const rect = element.getBoundingClientRect();
//           // Check if the top of the element is within the viewport
//           if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
//             currentActiveId = id;
//             break; // Found the most visible element, no need to check further
//           }
//         }
//       }
//       setActiveImageId(currentActiveId);
//     };

//     // Add scroll event listener
//     window.addEventListener('scroll', handleScroll);

//     // Clean up the event listener on component unmount
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, [flatImageFiles]); // Re-run effect if flatImageFiles changes


//   return (
//     <div className="flex flex-col min-h-screen">
//       <Header />
//       <div className="flex flex-grow"> {/* Flex container for sidebar and main content */}
//         {/* Left Sidebar Navigation */}
//         <nav className="hidden md:block w-1/4 p-4 sticky top-0 h-screen overflow-y-auto text-sm" style={{ backgroundColor: '#7A6E62' }}>
//           <div className="flex flex-col"> {/* Use flex-col for vertical stacking */}
//             {brandContent.map((section) => (
//               <div key={generateId(section.section)} className="mb-6">
//                 <h3 className="font-bold text-gray-800 mb-2">{section.section}</h3>
//                 <ul>
//                   {section.images.map((image) => {
//  if (section.section === "Download materials") {
//  // Create a scroll link for the specific div
//  return (
//  <li key="download-materials-link" className="mb-1 ml-4">
//  <a href="#download-materials-section" className={`hover:underline ${activeImageId === 'download-materials-section' ? 'font-bold text-[#5F40A1]' : 'text-[#CFC7DF]'}`}>
//  Cosmelytix logo
//  </a>
//  </li>
//  );
//  } else {
//  const id = generateId(image.fileName);
//  return (
//  <li key={id} className="mb-1 ml-4"> {/* Added margin-left for indentation */}
//  <a href={`#${id}`} className={`hover:underline ${activeImageId === id ? 'font-bold text-[#5F40A1]' : 'text-[#CFC7DF]'}`}> {/* Apply highlighting based on activeImageId */}
//  {image.label}
//  </a>

//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </nav>

//         {/* Main Content Area */}
//         <main className="w-full md:w-3/4 max-w-full overflow-x-hidden flex flex-col items-center"> {/* Main content takes remaining width, removed padding and added overflow handling */}
//           {brandContent.map((section) => {
//  return (
//  <React.Fragment key={generateId(section.section)}> {/* Outer Fragment */}
//  {/* Render images if the section is not "Download materials" */}
//  {section.section !== "Download materials" && (
//  <React.Fragment>
//  {section.images.map((image) => {
//  const id = generateId(image.fileName);
//  return (
//  <img
//  key={id}
//  id={id} // Assign unique ID to each image
//  src={`${baseUrl}${image.fileName}`}
//  alt={image.label}
//  className="w-full h-auto" // Make image take max width of its container
//  />
//  );
//  })
//  }
//  </React.Fragment>
//  )}
//  {/* Add download links if the section is "Download materials" */}
//  {/* Note: We are checking for section.section here to render this block only for the specific section */}
//  {section.section === "Download materials" && ( 
//  <div className="flex flex-col space-y-4 mt-8 w-full px-4"> {/* Use w-full and remove items-center for full width */}
//  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_logo.svg" download className="w-full"> {/* Add w-full to anchor tag */}
//  <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full"> {/* Add w-full to button */}
//  Logo (SVG)
//  </button>
//  </a>
//  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_mini_logo.svg" download className="w-full"> {/* Add w-full to anchor tag */}
//  <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full"> {/* Add w-full to button */}
//  Symbol Logo (SVG)
//  </button>
//  </a>
//  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_logo.png" download className="w-full"> {/* Add w-full to anchor tag */}
//  <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full"> {/* Add w-full to button */}
//  Logo (PNG)
//  </button>
//  </a>
//  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_mini_logo.png" download className="w-full"> {/* Add w-full to anchor tag */}
//  <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full"> {/* Add w-full to button */}
//  Symbol Logo (PNG)
//  </button>
//  </a>
//  <br/>
//  </div>
//  )}
//  </React.Fragment>
//  );})}
//         </main>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default BrandPage;
import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const BrandPage = () => {
  const baseUrl = "https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/brand-book/";
  const brandContent = [
    {
      section: "Overview",
      images: [{ fileName: "MacBook Pro 16_ - 1.png", label: "Overview" }],
    },
    {
      section: "Typography",
      images: [
        { fileName: "MacBook Pro 16_ - 2.png", label: "Typography" },
        { fileName: "MacBook Pro 16_ - 11.png", label: "Web Fonts" },
      ],
    },
    {
      section: "Pallet",
      images: [
        { fileName: "MacBook Pro 16_ - 3.png", label: "Pallet" },
        { fileName: "Group 122.png", label: "Additional colours" },
      ],
    },
    {
      section: "Blue Print",
      images: [
        { fileName: "MacBook Pro 16_ - 4.png", label: "Symbol" },
        { fileName: "MacBook Pro 16_ - 5.png", label: "Logo" },
      ],
    },
    {
      section: "Ideology",
      images: [
        { fileName: "MacBook Pro 16_ - 6.png", label: "symbol encoding" },
        { fileName: "MacBook Pro 16_ - 7.png", label: "Inspiration" },
        { fileName: "MacBook Pro 16_ - 8.png", label: "Values" },
      ],
    },
    {
      section: "Assets",
      images: [
        { fileName: "MacBook Pro 16_ - 9.png", label: "Branding assets" },
        { fileName: "Streen_Sign_Mockup_21 1.png", label: "Street sign" },
        { fileName: "Billboard_Mockup_4 1.png", label: "Bullboard" },
      ],
    },
    {
      section: "Download materials",
      images: [
        { fileName: "MacBook Pro 16_ - 10.png", label: "Cosmelytix Logo" },
      ],
    },
  ];

  const flatImageFiles = brandContent.reduce((acc, section) => acc.concat(section.images), []);
  const generateId = (str) => str.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
  const [activeImageId, setActiveImageId] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      let currentActiveId = null;
      for (const image of flatImageFiles) {
        const id = generateId(image.fileName);
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
            currentActiveId = id;
            break;
          }
        }
      }
      setActiveImageId(currentActiveId);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [flatImageFiles]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-grow">
        {/* Sidebar */}
        <nav className="hidden md:block w-1/4 p-4 sticky top-0 h-screen overflow-y-auto text-sm" style={{ backgroundColor: '#7A6E62' }}>
          <div className="flex flex-col">
            {brandContent.map((section) => (
              <div key={generateId(section.section)} className="mb-6">
                <h3 className="font-bold text-gray-800 mb-2">{section.section}</h3>
                <ul>
                  {section.images.map((image) => {
                    if (section.section === "Download materials") {
                      return (
                        <li key="download-materials-link" className="mb-1 ml-4">
                          <a
                            href="#download-materials-section"
                            className={`hover:underline ${activeImageId === 'download-materials-section' ? 'font-bold text-[#5F40A1]' : 'text-[#CFC7DF]'}`}
                          >
                            Cosmelytix logo
                          </a>
                        </li>
                      );
                    } else {
                      const id = generateId(image.fileName);
                      return (
                        <li key={id} className="mb-1 ml-4">
                          <a
                            href={`#${id}`}
                            className={`hover:underline ${activeImageId === id ? 'font-bold text-[#5F40A1]' : 'text-[#CFC7DF]'}`}
                          >
                            {image.label}
                          </a>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            ))}
          </div>
        </nav>

        {/* Main Content */}
        <main className="w-full md:w-3/4 max-w-full overflow-x-hidden flex flex-col items-center">
          {brandContent.map((section) => (
            <React.Fragment key={generateId(section.section)}>
              {section.section !== "Download materials" &&
                section.images.map((image) => {
                  const id = generateId(image.fileName);
                  return (
                    <img
                      key={id}
                      id={id}
                      src={`${baseUrl}${image.fileName}`}
                      alt={image.label}
                      className="w-full h-auto"
                    />
                  );
                })}

              {section.section === "Download materials" && (
                <div id="download-materials-section" className="flex flex-col space-y-4 mt-8 w-full px-4">
                  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_logo.svg" download className="w-full">
                    <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full">
                      Logo (SVG)
                    </button>
                  </a>
                  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_mini_logo.svg" download className="w-full">
                    <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full">
                      Symbol Logo (SVG)
                    </button>
                  </a>
                  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_logo.png" download className="w-full">
                    <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full">
                      Logo (PNG)
                    </button>
                  </a>
                  <a href="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_mini_logo.png" download className="w-full">
                    <button className="bg-[#C58348] hover:bg-[#5F40A1] text-white font-bold py-2 px-4 rounded w-full">
                      Symbol Logo (PNG)
                    </button>
                  </a>
                  <br></br>
                </div>
                
              )}
            </React.Fragment>
          ))}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default BrandPage;
